export default __webpack_public_path__ + "static/media/ikeja.05909700.svg";